import { Component, OnInit, ViewChild } from '@angular/core';
import { DeliverySearch } from '../../models/delivery-search';
import { DeliveryOperativeDto } from '../../models/delivery-operative-dto';
import { ApiService } from '../../../../core/services/api.service';
import { ComboDto } from '../../../../dtos/combo-dto';
import { ItemShipDetail } from '../../../../Models/item-ship-detail';
import { ShipDetailEnum } from '../../../../enums/ship-detail-enum';
import { ShipHistoryEnum } from '../../../../enums/ship-history-enum';
import { GenericModalComponent } from '../../generics/modal/generic-modal.component';
import { MatDialog, MatPaginator } from '@angular/material';
import { MessageService } from '../../../../core/services/message.service';
import { tap } from 'rxjs/operators';
import { merge } from 'rxjs/internal/observable/merge';
import { HttpParams } from '@angular/common/http';
import { JustificationModalComponent } from '../../generics/modal/justification-modal.component';

@Component({
  selector: 'delivery-storer',
  templateUrl: './delivery-storer.component.html',
  styleUrls: ['./delivery-storer.component.scss']
})

export class DeliveryStorerComponent implements OnInit {

  search: DeliverySearch;
  data: DeliveryOperativeDto[];
  rejectedList: ComboDto[];
  vehicleList: ComboDto[];
  rejectId: number;
  statusDetail = ShipDetailEnum;
  groupData = [];

  @ViewChild(MatPaginator) paginator: MatPaginator;
  totalElements: number = 10;

  constructor(private apiService: ApiService, private dialog: MatDialog, private messageService: MessageService) { }

  ngOnInit(): void {
    this.search = new DeliverySearch(new Date(), new Date(), 0, null, null, null);
    this.loadCombo();
    this.loadVehicle();
  }

  ngAfterViewInit(): void {
    merge(this.paginator.page).pipe(
      tap(() => {
        this.onSearchEvent(this.search)
      })
    ).subscribe();
  }

  public onSearchEvent(search: DeliverySearch): void {
    this.search = new DeliverySearch(search.initDate, search.endDate, search.vehicle, null, search.client, search.shipDetailList);
    //if (this.search.vehicle) {
      this.loadGrid(this.search);
    //}
  }

  public onPrintEvent(search: DeliverySearch): void {
    this.search = new DeliverySearch(search.initDate, search.endDate, search.vehicle, null, search.client, search.shipDetailList);
    //if (this.search.vehicle) {
      this.print(this.search);
    //}
  }

  private print(search: DeliverySearch){
    let params: HttpParams = new HttpParams();
    let value;
    for (let key in search) {
      if (search[key] instanceof Date) {
        value = search[key].toISOString();
      } else {
        value = search[key];
      }
      if(key !== 'status') {
        if(key === 'shipDetailList') {
          if(value instanceof Array) {
            for(let v in value) {
              params = params.append('status', value[v]);
            }
          }
        } else {
          params = params.append(key, value);
        }
      }
    }
    this.apiService.get('api/ship/printDevolutions', params)
      .subscribe((response: any) => {
        if (response.data) {
         
        this.download(response.data.document, response.data.myme, "devoluciones", ".pdf");
        }
      });
  }

  private b64toBlob(b64Data: string, contentType: string, sliceSize: number) : Blob {
    contentType = contentType || 'application/octet-stream';
    sliceSize = sliceSize || 512;
  
    let byteCharacters = atob(b64Data);
    let byteArrays = [];
  
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      let slice = byteCharacters.slice(offset, offset + sliceSize);
  
      let byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
  
      let byteArray = new Uint8Array(byteNumbers);
  
      byteArrays.push(byteArray);
    }
  
    let blob = new Blob(byteArrays, {type: contentType});
    return blob;
  }

  private download(b64Data: string, contentType: string, name: string, extension: string) : void {
    
    if(b64Data.includes('base64,')) {
      b64Data = b64Data.substring(b64Data.lastIndexOf(',') + 1)
    }

    let blob = this.b64toBlob(b64Data, contentType, null);
    let blobUrl = URL.createObjectURL(blob);

   // window.open(blobUrl, '_blank');
      var a = document.createElement('a')
      if (typeof a.download === 'undefined') {
        window.location.assign(blobUrl);
      } else {
        a.href = blobUrl
        if (name) {
          a.download = name + '.' + extension;
        } else {
          a.download = 'evidence' + '.' + extension;
        }
        document.body.appendChild(a)
        a.click()
      }
  }

  private loadGrid(search: DeliverySearch): void {
    let params: HttpParams = new HttpParams();
    params = params.append("page", this.paginator.pageIndex.toString());
    params = params.append("pageSize", this.paginator.pageSize.toString());
    
    let value;
    for (let key in search) {
      if (search[key] instanceof Date) {
        value = search[key].toISOString();
      } else {
        value = search[key];
      }
      if(key !== 'status') {
        if(key === 'shipDetailList') {
          if(value instanceof Array) {
            for(let v in value) {
              params = params.append('status', value[v]);
            }
          }
        } else {
          params = params.append(key, value);
        }
      }
    }
    
    this.apiService.get<DeliveryOperativeDto[]>('api/Delivery/getDeliveryStorer', params)
      .subscribe((response: any) => {
        if (response) {
          this.data = response.data.items;
          this.totalElements = response.data.totalElements;
          this.group();
        }
      });
  }

  private group() {
    let property = 'guideNumber';
    let groupData = this.data.reduce((previous, current) => {
      if(!previous[current[property]]) {
          previous[current[property]] = [current];
      } else {
          previous[current[property]].push(current);
      }

      return previous;
    }, {});

    this.groupData = Object.keys(groupData).map(key => ({
      key, value: groupData[key]
    }));
  }

  private loadCombo(): void {
    this.apiService.get<ComboDto[]>('api/Delivery/getJustificationCombo')
      .subscribe((response: ComboDto[]) => {
        if (response) {
          this.rejectedList = response;
        }
      });
  }

  private loadVehicle(): void {
    this.apiService.get<ComboDto[]>('api/Vehicle/getVehicleCombo')
      .subscribe((response: ComboDto[]) => {
        if (response) {
          this.vehicleList = response;
        }
      });
  }

  public onMove(id: number, idShip: number, idVehicleFrom: number, idVehicleTo: number): void {
    const dialogRef = this.dialog.open(JustificationModalComponent, {
      width: '250px',
      data: {
        title: 'DELIVERY_STORER.MESSAGES.TITLE_QUESTION',
        question: 'DELIVERY_STORER.MESSAGES.QUESTION_MOVE',
        justifications: this.rejectedList
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onAcceptMove(id, idShip, idVehicleFrom, idVehicleTo, result);
      }
    });
  }

  private onAcceptMove(id: number, idShip: number, idVehicleFrom: number, idVehicleTo: number, idJustification: number): void {
    this.apiService.put<boolean>('api/load/updateShipOrder', { id: id, idShip: idShip, idVehicleFrom: idVehicleFrom, idVehicleTo: idVehicleTo, idJustification: idJustification, movement: ShipHistoryEnum.MOVE_SHIP_STORER })
      .subscribe((response) => {
        if(response) {
          this.loadGrid(this.search);
          this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'DELIVERY_STORER.MESSAGES.FUNCTION_SHIP',
              action: 'DELIVERY_STORER.MESSAGES.ACTION_MOVE'
            });
        }
      });
  }

  public onDelete(id: number, idShip: number, idJustification: number): void {
    const dialogRef = this.dialog.open(GenericModalComponent, {
      width: '250px',
      data: {
        title: 'DELIVERY_STORER.MESSAGES.TITLE_QUESTION',
        question: 'DELIVERY_STORER.MESSAGES.QUESTION_INACTIVE'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.onAcceptDelete(id, idShip, idJustification);
      }
    });
  }

  public onAcceptDelete(id: number, idShip: number, idJustification: number): void {
    this.apiService.put<boolean>('api/load/inactiveShip', { id: id, idShip: idShip, idJustification: idJustification, movement: ShipHistoryEnum.DELTE_STORER })
      .subscribe((response) => {
        if(response) {
          this.loadGrid(this.search);
          this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'DELIVERY_STORER.MESSAGES.FUNCTION_SHIP',
              action: 'DELIVERY_STORER.MESSAGES.ACTION_DELETE'
            });
        }
      });
  }

  public onAdd(item: DeliveryOperativeDto) {
    let detail: ItemShipDetail = {
      id: item.idShipDetail,
      item: { id: item.idItem },
      nUnities: item.nUnities,
      statusDetail: ShipDetailEnum.LOADED
    };

    this.update(item, detail);
  }

  public onRejected(item: DeliveryOperativeDto, idRejected: number) {
    let detail: ItemShipDetail = {
      id: item.idShipDetail,
      item: { id: item.idItem },
      nUnities: item.nUnities,
      justification: { id: idRejected },
      statusDetail: ShipDetailEnum.REJECTED
    };

    this.openDialog(item, detail);
  }

  private openDialog(item: DeliveryOperativeDto, detail: ItemShipDetail): void {
    const dialogRef = this.dialog.open(GenericModalComponent, {
      width: '250px',
      data: {
        title: 'DELIVERY_STORER.MESSAGES.TITLE_QUESTION',
        question: 'DELIVERY_STORER.MESSAGES.QUESTION'
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.update(item, detail);
      }
    });
  }

  private update(item: DeliveryOperativeDto, detail: ItemShipDetail): void {
    this.apiService.put<boolean>('api/Delivery/updateItem', detail)
      .subscribe((response: boolean) => {
        if (response) {
          item.statusDetail = detail.statusDetail;
          this.messageService.success('GENERAL.MESSAGE.TITLE_SUCCESS', 'GENERAL.MESSAGE.SUCCESS',
            {
              article: 'GENERAL.MESSAGE.THE_1',
              function: 'DELIVERY_STORER.MESSAGES.FUNCTION',
              action: (detail.statusDetail == ShipDetailEnum.LOADED ? 'DELIVERY_STORER.MESSAGES.ACTION_ADD' : 'DELIVERY_STORER.MESSAGES.ACTION_REJECT')
            });
        }
      });
  }

  public getIcon(status: ShipDetailEnum): string {
    if (status == ShipDetailEnum.WAREHOUSE) {
      return 'location_city';
    } else if (status == ShipDetailEnum.LOADED) {
      return 'local_shipping';
    } else if (status = ShipDetailEnum.REJECTED) {
      return 'cancel_presentation';
    }

    return '';
  }
}
